/**
 * Get recaptcha score and then submit
 * Drop-in fix for pages with multiple forms / multiple recaptcha-score inputs.
 */
function getRecaptchaAndSubmit(submitCallback, submitArgs) {
    // 1) Prefer the recaptcha input inside the form that triggered submit
    // submitArgs might be a form element in some call sites; support that.
    let recaptchaScore = null;

    if (submitArgs && typeof submitArgs.querySelector === 'function') {
        recaptchaScore =
            submitArgs.querySelector('#recaptcha-score') ||
            submitArgs.querySelector('input[name="recaptcha_score"]');
    }

    // 2) If not found, try the currently focused element's form
    // (works when user clicked a submit button inside the form)
    if (!recaptchaScore) {
        const activeForm = document.activeElement && document.activeElement.form;
        if (activeForm) {
            recaptchaScore =
                activeForm.querySelector('#recaptcha-score') ||
                activeForm.querySelector('input[name="recaptcha_score"]');
        }
    }

    // 3) If still not found, fall back to "the first one" (old behavior)
    if (!recaptchaScore) {
        recaptchaScore =
            document.getElementById('recaptcha-score') ||
            document.querySelector('input[name="recaptcha_score"]');
    }

    if (!recaptchaScore) {
        console.warn('Recaptcha input not found; submitting anyway.');
        submitCallback(submitArgs);
        return;
    }

    const recaptchaDiv =
        recaptchaScore.closest('.recaptcha-container') ||
        recaptchaScore.closest('div') ||
        recaptchaScore.parentElement;

    // show loader (avoid duplicates)
    if (recaptchaDiv && !recaptchaDiv.querySelector('.loader')) {
        recaptchaDiv.insertAdjacentHTML('beforeend', `<div class="loader"></div>`);
    }

    grecaptcha.ready(function () {
        grecaptcha
            .execute('6LeMgfMqAAAAAHvexCmpW9kOzAuqeVo-hKPnPxbQ', { action: 'submit' })
            .then(function (token) {
                const apiUrl =
                    `https://gt2b776n3ai6mq77g6xz3rizfi0pcftt.lambda-url.us-east-2.on.aws/validate?token=${encodeURIComponent(token)}`;

                fetch(apiUrl)
                    .then((response) => response.json())
                    .then((data) => {
                        const minScore = Number(recaptchaScore.dataset.min_score) || 0.3;

                        if (data.valid && data.score > minScore) {
                            recaptchaScore.value = data.score;
                            submitCallback(submitArgs);
                        } else {
                            recaptchaScore.value = -5; // suspicious
                            submitCallback(submitArgs);
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        recaptchaScore.value = -2;
                        submitCallback(submitArgs);
                    });
            });
    });
}

window.getRecaptchaAndSubmit = getRecaptchaAndSubmit;
